import * as THREE from "three";

/**
 * Меняет цвет материалов с указанным именем во всех дочерних объектах и самом объекте.
 *
 * @param {THREE.Object3D} object - Главный 3D-объект, по которому происходит перебор.
 * @param {string} materialName - Имя материала, который необходимо перекрасить.
 * @param {string|THREE.Color} newColor - Новый цвет (строка или экземпляр THREE.Color).
 * @returns {void}
 */
export const changeMaterialColor = (object, materialName, newColor) => {
    // --- Проверки входных данных ---
    if (!object || typeof object.traverse !== "function") {
        console.warn("❌ changeMaterialColor: некорректный объект (ожидается Object3D).");
        return;
    }

    if (typeof materialName !== "string" || !materialName.length) {
        console.warn("❌ changeMaterialColor: некорректное имя материала.");
        return;
    }

    if (!newColor) {
        console.warn("❌ changeMaterialColor: не задан новый цвет.");
        return;
    }

    // --- Проверка HEX ---
    const isValidHex = (val) => typeof val === "string" && /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/i.test(val.trim());

    // --- Приведение newColor к массиву ---
    let colors = [];

    if (Array.isArray(newColor)) {
        colors = newColor.filter(isValidHex);
    } else if (typeof newColor === "string") {
        if (newColor.includes("|")) {
            colors = newColor
                .split("|")
                .map((c) => c.trim())
                .filter(isValidHex);
        } else if (isValidHex(newColor)) {
            colors = [newColor.trim()];
        }
    }

    if (colors.length === 0) {
        console.error("❌ changeMaterialColor: переданы некорректные HEX значения:", newColor);
        return;
    }

    // --- Применяем цвета ---
    object.traverse((child) => {
        if (!child.material) return;

        const materials = Array.isArray(child.material) ? child.material : [child.material];

        materials.forEach((mat) => {
            if (!mat?.name || !mat.name.includes(materialName) || !mat.color?.set) return;

            // 🎨 Если несколько цветов — распределяем по суффиксам
            if (colors.length > 1) {
                if (mat.name.endsWith("_1")) {
                    mat.color.set(colors[0]);
                } else if (mat.name.endsWith("_2")) {
                    mat.color.set(colors[1]);
                } else {
                    // fallback для материалов без суффиксов
                    mat.color.set(colors[0]);
                }
            } else {
                // один цвет — просто применяем
                mat.color.set(colors[0]);
            }

            // сохраняем оригинальный цвет (если нужно)
            mat.userData.originalColor = new THREE.Color(mat.color);
            mat.needsUpdate = true;
        });
    });
};
const DEFAULT_COLORS = {
    changeable_painted_metal_material: "#cbd0cc",
    changeable_kromka_material: "#868684",
};
export const setTableDefaultColor = (tableArr) => {
    const matMetalName = "changeable_painted_metal_material";
    const matKromkaName = "changeable_kromka_material";

    // Безопасно извлекаем цвета, подставляем DEFAULT при отсутствии
    const metalColor = servObj?.tableColor?.[matMetalName]?.default ?? DEFAULT_COLORS[matMetalName];
    const kromkaColor = servObj?.tableColor?.[matKromkaName]?.default ?? DEFAULT_COLORS[matKromkaName];

    // Проверка на случай, если default присутствует, но равен null или пустой строке
    const safeMetalColor =
        metalColor && typeof metalColor === "string" && metalColor.trim() !== ""
            ? metalColor
            : DEFAULT_COLORS[matMetalName];
    const safeKromkaColor =
        kromkaColor && typeof kromkaColor === "string" && kromkaColor.trim() !== ""
            ? kromkaColor
            : DEFAULT_COLORS[matKromkaName];

    // Применяем цвета ко всем переданным объектам
    tableArr.forEach((table) => {
        changeMaterialColor(table, matMetalName, safeMetalColor);
        changeMaterialColor(table, matKromkaName, safeKromkaColor);
    });
};

export const changeObjColor = (arr) => {
    if (!Array.isArray(arr) || !arr.length) {
        console.error("[changeObjColor] Что-то не так", arr);
        return;
    }

    arr.forEach((activeObj) => {
        if (activeObj && typeof activeObj.traverse === "function") {
            changeMaterialColor(
                activeObj,
                "changeable_painted_metal_material",
                servObj.tableColor.changeable_painted_metal_material.current,
            );
            changeMaterialColor(
                activeObj,
                "changeable_kromka_material",
                servObj.tableColor.changeable_kromka_material.current,
            );
        }
    });
};
